<template>
  <div class="lab-result-check">
    <div
      class="vital-select-input-group el-input-group el-input-group--append el-input-group--prepend"
    >
      <div class="el-input-group__prepend">Is</div>
      <el-card :body-style="{ padding: '8px' }">
        Glucose        
      </el-card>
    </div>

    <el-select
      v-if="state.check.id"
      id="operator-select"
      v-close-on-zoom
      :value="state.check.operator"
      placeholder="="
      class="operator-select"
      :disabled="readonly"
      @input="operator => updateOperator(operator)"
    >
      <el-option v-for="op in state.operators" :key="op.value" :label="op.label" :value="op.value" />
    </el-select>
    
    <state-input
      v-if="state.check.id"
      :state="vitalsByKey[state.check.id]"
      :initial-value="state.check.value"
      :show-label="false"
      width="100px"
      :disabled="readonly"
      :use-default="useDefault"
      class="value-input"
      @input="value => updateValue(parseInt(value))"
    >
      <template slot="append">?</template>
    </state-input>
  </div>
</template>

<script>
import keyBy from 'lodash/keyBy';

import StateInput from '~lib/common/components/StateInput';

export default {
  name: 'lab-result-check',
  components: {
    StateInput,
  },
  props: [
    'states',
    'readonly',
    'emitter',
    'ikey',
    'getData',
    'putData',
    'control',
    'category',
    'type',
    'useDefault',
  ],
  data() {
    return {
      state: {
        vitals: this.states.filter(s => s.category === this.category),
        check: {},
        operators: [
          { value: 'LESS_THAN', label: '<' },
          { value: 'LESS_THAN_OR_EQUAL', label: '≤' },
          { value: 'EQUAL', label: '=' },
          { value: 'NOT_EQUAL', label: '≠' },
          { value: 'GREATER_THAN_OR_EQUAL', label: '≥' },
          { value: 'GREATER_THAN', label: '>' },
        ],
      },
    };
  },
  computed: {
    vitalsByKey() {
      return keyBy(this.state.vitals, 'key');
    },
  },
  mounted() {    
    this.state.check = this.getData(this.ikey) || {};
    if (!this.state.check.id) {
      this.state.check.id = 'GLUCOSE';
      this.state.check.operator = this.state.operators[0].value;
    }
    this.emitter.trigger('process', this.control);
  },
  methods: { 
    updateOperator(operator) {
      this.state.check.operator = operator;
      this.update();
    },
    updateValue(value) {
      this.state.check.value = value;
      this.update();
    },
    update() {
      this.putData(this.ikey, {
        type: this.type,
        ...this.state.check,
      });
      this.emitter.trigger('process', this.control);
      this.$forceUpdate();
    },
  }
}
</script>

<style scoped>
.lab-result-check {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.lab-result-check .el-card {
  color: black;
}

.operator-select {
  width: 130px;
}
</style>